<script setup lang="ts">
import { Icon } from '@dashhudson/dashing-ui/icon';
import { VisionAiAnimation } from '@dashhudson/dashing-ui/vision-ai-animation';

import { useVisionFloatingButtonLayout } from '@/composables/layout/useFloatingWidgetLayout';

const emit = defineEmits<{
  'toggle-chat-window': [];
}>();

const { isChatPanelOpen, chatPanelTransformStyle, buttonPositionClasses } =
  useVisionFloatingButtonLayout();

function handleButtonClicked(event: MouseEvent) {
  event.stopPropagation();
  emit('toggle-chat-window');
}
</script>

<template>
  <div
    data-test="vision-ai-button-global"
    data-exclude-side-panel-close
    :class="[
      'vision-ai-button dash-transition-md !pointer-events-auto relative',
      buttonPositionClasses,
    ]"
    :style="[{ zIndex: '9999' }, chatPanelTransformStyle]"
  >
    <div
      :class="[
        'bg-vision-ai',
        'rounded-full',
        'py-2',
        'pl-2',
        'cursor-pointer',
        'overflow-hidden',
        'dash-transition-lg',
        '!max-w-10 pr-2',
      ]"
      @click="handleButtonClicked($event)"
    >
      <div class="flex justify-center overflow-hidden">
        <Icon
          v-if="isChatPanelOpen"
          name="chevron-right"
          :size="24"
          class="dash-fill-icon-knockout"
        />
        <VisionAiAnimation v-else disabled />
      </div>
    </div>
  </div>
</template>
